export function addItem(state, itemData) {
  state.items.push({
    product: itemData.item.product,
    id: itemData.item.id,
    license_id: itemData.item.license_id,
    name: itemData.item.name,
    category_type_name: itemData.item.category_type?.name,
    target_price: itemData.price_per_unit,
    target_price_total: itemData.price,
    unit_price: itemData.price_per_unit,
    total_price: itemData.price,
    inventory_value: itemData.inventory_value,
    inventory_unit: itemData.inventory_unit,
    last_order_value: itemData.inventory_value,
    last_order_unit: itemData.inventory_unit,
    last_ordered_at: itemData.last_ordered_at,
    last_unit_price: itemData.price_per_unit,
    last_unit_type: itemData.inventory_unit,
    supplier: {
      license_number: itemData.supplier_license_number,
      name: itemData.supplier_name,
      is_registered: itemData.supplier_is_registered
    },
    supplier_product: itemData.supplier_product,
    current_inventory_value: itemData.current_inventory_value,
    current_inventory_unit: itemData.current_inventory_unit,

    row: itemData.row
  });
}

export function removeItem(state, itemIndex) {
  state.items.splice(itemIndex, 1);
}

export function clearItems(state) {
  state.items = [];
}

export function setItemFieldValue(state, payload) {
  state.items[payload.index][payload.name] = payload.value;
}

export function clearState(state) {
  state.inventoryRows = [];
  state.rowsFormData = [];
  state.suppliersInfo = {};
  state.supplierPaymentTerms = {};
  state.vendorProductsInventory = {};
}

export function addInventoryRow(state, rowData) {
  console.log('PUSHING NEW ROW');
  console.log(rowData);
  state.inventoryRows.push(rowData);
}

export function removeInventoryRow(state, rowIndex) {
  state.inventoryRows.splice(rowIndex, 1);
}

export function updateInventoryRow(state, payload) {
  state.inventoryRows[payload.index] = payload.data;
}

export function updateInventoryRowFormData(state, payload) {
  state.inventoryRows[payload.index].formData = payload.data;
}

export function updateInventoryRowFormDataLicense(state, payload) {
  state.inventoryRows[payload.index].formData.licenses[payload.license_index] = payload.data;
}

export function addSupplierInfo(state, supplierData) {
  if (typeof state.suppliersInfo[supplierData.license_number] === 'undefined') {
    state.suppliersInfo[supplierData.license_number] = {
      facility_name: supplierData?.facility_name,
      first_name: supplierData?.first_name,
      last_name: supplierData?.last_name,
      email:supplierData?.email,
      phone: supplierData?.phone
    }
  }
}

export function clearSuppliersInfo(state) {
  state.suppliersInfo = {};
}

export function setSupplierInfoFieldValue(state, payload) {
  state.suppliersInfo[payload.license_number][payload.name] = payload.value;
}

export function setSupplierPaymentTerms(state, payload) {
  state.supplierPaymentTerms[payload.license_number] = payload.value;
}

export function setItemSales(state, payload) {
  let itemSales = {};
  if (typeof state.itemSales[payload.item_id] !== 'undefined') {
    itemSales = state.itemSales[payload.item_id];
  }
  itemSales[payload.license_id] = payload.sales;

  state.itemSales[payload.item_id] = itemSales;
}

export function clearItemSales(state) {
  state.itemSales = [];
}

export function setVendorProductInventory(state, payload) {
  state.vendorProductsInventory[payload.product_id] = payload.inventory;
}
